import axios from 'axios';

// Base configuration
const API_BASE_URL = 'https://anfopublicationhouse.com/api/endpoints/';

// Create single axios instance without Authorization headers
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Helper function to add auth token to request data instead of headers
const addAuthToData = (data = {}) => {
  const token = localStorage.getItem('adminToken');
  if (token) {
    return { ...data, auth_token: token };
  }
  return data;
};

// Helper function to add auth token to URL params
const addAuthToParams = (url) => {
  const token = localStorage.getItem('adminToken');
  if (token) {
    const separator = url.includes('?') ? '&' : '?';
    return `${url}${separator}auth_token=${token}`;
  }
  return url;
};

// Response interceptor for handling errors
const responseInterceptor = (response) => response;
const errorInterceptor = (error) => {
  if (error.response?.status === 401) {
    // Unauthorized - clear token and redirect to login
    localStorage.removeItem('adminToken');
    localStorage.removeItem('adminUser');
    window.location.href = '/login';
  }
  return Promise.reject(error);
};

api.interceptors.response.use(responseInterceptor, errorInterceptor);

export default api;
export { addAuthToData, addAuthToParams };